import { ComponentBase } from '@abstracts/component-base';
import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TransactionsService } from '@services/entity/transactions.service';
import { StripeInfosService } from '@services/entity/stripe-infos.service';
import { UserDto } from '@dto/userDto';
import { PricingsService } from '@services/entity/pricings.service';
import { PricingDto } from '@dto/pricingDto';
import { BillingMethodEnum } from '@enums/billingMethodEnum.enum';
import { CustomersService } from '@services/entity/customers.service';
import { UsersService } from '@services/entity/users.service';
import { TransactionDto } from '@dto/transactionDto';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent extends ComponentBase implements OnInit {

  public className = 'DashboardComponent';
  public showRunningTransactions: boolean = false;
  public runningTransactions: TransactionDto[]
  private user: UserDto = this.authenticationService.getLoggedInUser();
  public pricing: PricingDto;
  public showAutoBillingNotification: boolean = false

  public isOperator: boolean
  public hasBlackbox: boolean = false;
  public customerId: number;

  public componentReady: boolean = false;

  constructor(
    private transactionsService: TransactionsService,
    private stripeInfosService: StripeInfosService,
    private pricingsService: PricingsService,
    private customerService: CustomersService,
    private userService: UsersService,
    public activatedRoute: ActivatedRoute,
    private router: Router,
    injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.isOperator = false
    this.checkRolesAndInitRequest()
  }

  checkRolesAndInitRequest() {
    if (this.authenticationService.userHasRole('Technical')) {
      this.router.navigate(['/technical'], { replaceUrl: true });
      return;
    }
    if (this.authenticationService.userHasRole('Account')) {
      this.router.navigate(['/account'], { replaceUrl: true });
      return;
    }
    if (this.authenticationService.userHasRole('Operator')) {
      this.isOperator = true;
      this.customerId = this.activatedRoute.parent.snapshot.params.key;
      if (this.customerId == null) this.router.navigateByUrl("/operator");
    }
    this.checkRunningTransactions();
    if (this.isOperator) {
      if (this.customerId == null) return
      this.customerService.getMasterUserOfCustomer(this.customerId).subscribe(masterUser => {
        this.userService.getUserDtoById(masterUser.id).subscribe(user => {
          this.user = user
          if (this.user && this.user.pricingId) {
            this.getPricing()
          }
        })
      })
    } else {
      this.authenticationService.getLoggedInUserSubject().subscribe(user => {
        if (user == null) return
        this.user = user
        if (this.user && this.user.pricingId) {
          this.getPricing()
        }
      })
    }
    this.componentReady = true
  }

  getPricing() {
    if (this.user) {
      this.pricingsService.getPricing(this.user.pricingId).subscribe(pricing => {
        this.pricing = pricing;

        if (this.user && this.authenticationService.userHasRole("User")) {
          this.getStripeInfoOfUser()
        }
      }, error => { });
    }
  }

  getStripeInfoOfUser() {
    this.stripeInfosService.getStripeInfoOfUser(this.user.id).subscribe(stripeInfo => {
      if (this.user.pricingId != null
        && this.pricing.billingMethod == BillingMethodEnum.Automatic
        && !stripeInfo.stripePaymentMethodId) {
        this.showAutoBillingNotification = true
      }
    })
  }

  checkRunningTransactions() {
    if (this.isOperator) {
      if (this.customerId == null) return
      this.transactionsService.getRunningTransactionsOfCustomer(this.customerId).subscribe(result => {
        if (result.length >= 1) {
          this.runningTransactions = result;
          this.showRunningTransactions = true;
        }
      }, error => { });
    } else {
      this.transactionsService.getRunningTransactions().subscribe(result => {
        if (result.length >= 1) {
          this.runningTransactions = result;
          this.showRunningTransactions = true;
        }
      }, error => { });
    }
  }
}
